<template>
	<section role="main" class="content-body">
		<header class="page-header">
			<h2>學雜費減免系統</h2>
			<div class="right-wrapper">
				<ol class="breadcrumbs">
					<li>
						<router-link to="/">
							<i class="fa fa-home"></i>
						</router-link>
					</li>
					<li>學雜費減免系統</li>
				</ol>
			</div>
		</header>
		<router-view :key="$route.fullPath"></router-view>
	</section>
</template>
<script>
export default {
	mounted(){
		
	}
}
</script>
<style>
</style>